// extracted by mini-css-extract-plugin
module.exports = {"Textarea":"textarea_Textarea__1HgV-","inputBlock":"textarea_inputBlock__1SeNc"};